<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="primary" @click="handleAdd">新增</el-button>
		</el-col>
		<!--列表-->
		<el-table  stripe :data="datalist" highlight-current-row v-loading="listLoading" style="width: 100%;" height="900">
			<el-table-column type="index" label="编号" width="60">
			</el-table-column>
			<el-table-column prop="menuno" label="菜单编号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="menuname" label="菜单名称" width="180">
			</el-table-column>
			<el-table-column prop="menuoreder" label="序号" width="120" >
			</el-table-column>
			<el-table-column prop="menupathinfo" label="路径" width="230" >
			</el-table-column>
			<el-table-column prop="menuremark" label="描述" width="250">
			</el-table-column>
			<el-table-column label="操作" width="150">
				<template scope="scope">
					<el-button type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="text" @click="handleDel(scope.$index, scope.row)" icon="el-icon-delete"></el-button>
				</template>
			</el-table-column>
		</el-table>


		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="formRules" ref="editForm">
				<el-form-item label="菜单编号" prop="menuno">
					<el-input v-model="editForm.menuno" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="菜单名称" prop="menuname">
					<el-input v-model="editForm.menuname" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="序号" prop="menuoreder">
					<el-input v-model="editForm.menuoreder" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="路径" prop="menupathinfo">
					<el-input v-model="editForm.menupathinfo" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="menuremark">
					<el-input type="textarea" v-model="editForm.menuremark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				datalist: [],
				total: 0,//总记录数
				pagesize:2000,//每页条数
				page: 1,//默认第几页
				listLoading: false,
				
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					menuno: [
						{ required: true, message: '请输入菜单编号', trigger: 'blur' }
					],
					menuname: [
						{ required: true, message: '请输入菜单名称', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					actionurl:'',
					sqlid:'',
					id:0,
					menuno: '',
					menuname:'',
					menuoreder:'',
					menupathinfo:'',
					menuremark:'',
					isshow:'0'					
				}
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			//获取用户列表
			getLists() {
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					sqlid:'roles.querymenus',
				};
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				let para = { 
					id: row.id,
					actionurl:'default/del',
					sqlid:'roles.delmenus'
				};
				util.deleteFunction(this,para);
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				console.log("actionurl="+this.editForm.actionurl);
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'roles.uptmenus';//设置Sqlid
				console.log("actionurl="+this.editForm.actionurl);
			},
			//显示新增界面
			handleAdd: function () {
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',
					sqlid:'roles.addmenus',
					id:0,
					menuno: '',
					menuname:'',
					menuoreder:'',
					menupathinfo:'',
					menuremark:'',
					isshow:'0'
				};
			},
			//编辑保存
			editSubmit: function () {
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			}
		},
		mounted() {
			this.getLists();
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// MenusList.vue?5283d6e6